import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import menu from '../Data/Menu/menu.json';
import menu2 from '../Data/Menu/menu2.json';
import { useHasPermission } from "../../hooks/permission";
import logo from '../../assets/images/The-Key-Logo.png';

function Sidebar(props) {
    const navigate = useNavigate();
    const [isSidebarMini, setIsSidebarMini] = useState(false);
    const [menuData, setMenuData] = useState([...menu.menu]);
    const { activekey } = props;

    const openChildren = (id) => {
        const allTabs = document.getElementsByClassName("has-children");
        for (let i = 0; i < allTabs.length; i++) {
            if (allTabs[i].id !== id) {
                allTabs[i].classList.remove("show");
                if (allTabs[i].parentElement.children.length > 1) {
                    allTabs[i].parentElement.children[0].setAttribute("aria-expanded", "false");
                }
            }
        }

        const current = document.getElementById(id);
        if (current) {
            const expanded = current.classList.contains("show");
            current.classList.toggle("show");
            if (current.parentElement.children.length > 1) {
                current.parentElement.children[0].setAttribute("aria-expanded", !expanded ? "true" : "false");
            }
        }
    };

    const openChildren1 = (id) => {
        const allTabs = document.getElementsByClassName("has-children");
        for (let i = 0; i < allTabs.length; i++) {
            allTabs[i].classList.remove("show");
        }
        const current = document.getElementById(id);
        if (current) {
            current.classList.add("show");
            if (current.parentElement.children.length > 1) {
                current.parentElement.children[0].setAttribute("aria-expanded", "true");
            }
        }
    };

    const GotoChangeMenu = (val) => {
        if (val === "UI Components") {
            navigate("ui-alerts");
            setMenuData([...menu2.menu2]);
        } else {
            navigate("accounts/dashboard");
            setMenuData([...menu.menu]);
        }
    };

    const MenuItem = ({ ind, data, permission }) => {
        const hasAccess = useHasPermission(permission);
        const navigate = useNavigate();
        
        if (permission && !hasAccess) return null;
        
        const handleClick = (e) => {
            e.preventDefault();
            // Navigate to the route
            navigate(process.env.PUBLIC_URL + "/" + data.routerLink[0]);
            
            // Close sidebar on mobile view
            const sidebar = document.getElementById('mainsidemenu');
            if (window.innerWidth < 992 && sidebar) {
                sidebar.classList.remove('open');
            }
        };
        
        return (
            <li key={"child-" + ind}>
                <Link
                    className={activekey === "/" + data.routerLink[0] ? "ms-link active" : "ms-link"}
                    to={process.env.PUBLIC_URL + "/" + data.routerLink[0]}
                    onClick={handleClick}>
                    <span>{data.name}</span>
                </Link>
            </li>
        );
    };

    const MenuItemNoChild = ({ key, data, permission }) => {
        const hasAccess = useHasPermission(permission);
        const navigate = useNavigate();
        
        if (permission && !hasAccess) return null;
        
        const handleClick = (e) => {
            e.preventDefault();
            // Navigate to the route
            navigate(process.env.PUBLIC_URL + "/" + data.routerLink[0]);
            
            // Close sidebar on mobile view
            const sidebar = document.getElementById('mainsidemenu');
            if (window.innerWidth < 992 && sidebar) {
                sidebar.classList.remove('open');
            }
        };
        
        return (
            <li key={key} className="collapsed">
                <Link
                    to={process.env.PUBLIC_URL + "/" + data.routerLink[0]}
                    className={`m-link ${"/" + data.routerLink[0] === activekey ? "active" : ""}`}
                    onClick={handleClick}>
                    <i className={data.iconClass}></i>
                    <span>{data.name}</span>
                    <span className="ms-auto text-end fs-5"></span>
                </Link>
            </li>
        );
    };

    const MenuItemWithChild = ({ key, i, data, permission }) => {
        const hasAccess = useHasPermission(permission);
        if (permission && !hasAccess) return null;

        const isActive = data.children.some(child => "/" + child.routerLink[0] === activekey);

        return (
            <li key={key} className="collapsed">
                <a
                    className={`m-link ${isActive ? "active" : ""}`}
                    href="#!"
                    onClick={(e) => {
                        e.preventDefault();
                        openChildren("menu-Pages" + i);
                    }}>
                    <i className={data.iconClass}></i>
                    <span>{data.name}</span>
                    <span className="arrow icofont-dotted-down ms-auto text-end fs-5"></span>
                </a>
                {data.children.length > 0 &&
                    <ul className="sub-menu collapse has-children" id={"menu-Pages" + i}>
                        {data.children.map((child, ind) => {
                            if ("/" + child.routerLink[0] === activekey) {
                                setTimeout(() => openChildren1("menu-Pages" + i), 100);
                            }
                            
                            return (
                                <MenuItem 
                                    key={ind} 
                                    ind={ind} 
                                    data={child} 
                                    permission={child.permission}
                                />
                            );
                        })}
                    </ul>}
            </li>
        );
    };

    return (
        <div
            id="mainsidemenu"
            className={`sidebar px-4 py-4 py-md-4 me-0 ${isSidebarMini ? "sidebar-mini" : ""}`}
            style={{ overflow: 'scroll' }}
        >
            <div className="d-flex flex-column h-100">
                <a href="/" className="mb-0 brand-icon">
                    <span className="logo-icon">
                        <img src={logo} alt="Logo" style={{ width: '70px'}} />
                    </span>
                </a>
                <ul className="menu-list flex-grow-1 mt-3">
                    {menuData.map((d, i) => {
                        if (d.isToggled) {
                            return (
                                <li key={"toggled" + i}>
                                    <a
                                        className={`m-link`}
                                        href="#!"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            GotoChangeMenu(d.name);
                                        }}>
                                        <i className={d.iconClass}></i>
                                        <span>{d.name}</span>
                                    </a>
                                </li>
                            );
                        }
                        if (d.children.length === 0) {
                            return <MenuItemNoChild key={"menu-" + i} data={d} permission={d.permission} />;
                        }
                        return <MenuItemWithChild key={"menu-parent-" + i} i={i} data={d} permission={d.permission} />;
                    })}
                </ul>
                <button
                    type="button"
                    className="btn btn-link sidebar-mini-btn text-light"
                    onClick={() => setIsSidebarMini(!isSidebarMini)}
                >
                    <span className="ms-2"><i className="icofont-bubble-right"></i></span>
                </button>
            </div>
        </div>
    );
}

export default Sidebar;
